import { fetchData } from './fetchData';
import { Repair } from '../data/Repair';

export type RepairProgressRequestData = {
    // 查詢類型 1:會員/2:非會員/3:歷史維修紀錄
    type: '1' | '2' | '3',
    // 產品識別碼
    barcode: string,
    // 產品序號
    sn_code: string,
    // 產品型號
    product_model_id: string,
    // 送修日期(起)
    repair_date: string,
    // 送修日期(迄)
    repair_date_e: string,
    // 維修狀態
    stage_name_id: string,
    // LINE ID
    line_uid: string,
    // 帳號
    login: string,
    // 報修單號
    name: string,
    // email
    email: string,
};

export type RepairProgressHistoryData = RepairProgressRequestData & {
    // 查詢類型 1:會員/2:非會員/3:歷史維修紀錄
    type:'3',
};

function repairProgress(data: RepairProgressRequestData): Promise<Repair[]> {
    return fetchData('api/repair_progress', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: Repair[]) => resData);
}

function repairProgressHistory(data: RepairProgressRequestData): Promise<Repair[]> {
    return fetchData('api/repair_progress', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: Repair[]) => resData);
}

export {
    repairProgress,
    repairProgressHistory,
};
